import template from './form-builder-node-components.html';

export default {
	bindings: {
		components: '<?',
	},
	template,
};
